import { IconButton, InputAdornment, Stack } from '@mui/material';
import { InputText } from '../elements/InputText';
import React, { ChangeEvent, useState } from 'react';
import { ButtonCustom } from '../elements/ButtonCustom';
import { PagingInfo } from 'types/paging';
import { Document } from 'types/room';
import { HEADER_DOCUMENT } from 'const/report';
import { TableCustom } from '../elements/TableCustom';
import { TextEllipsis } from '../elements/TextEllipsis';
import dayjs from 'dayjs';

type RenderDataProps = {
  dataTable: Document[];
  saveVideo?: (url: string, fileName: string) => void;
  deleteRecord?: (id: number) => void;
};
const renderDataTable = ({ dataTable, deleteRecord }: RenderDataProps) => {
  return dataTable.map((data) => {
    return {
      title: {
        value: <TextEllipsis text={data.title || `report - ${data?.id}`} width={'95%'} />
      },
      createdAt: {
        value: <TextEllipsis text={dayjs(data.updatedAt).format('YYYY-MM-DD')} width={'95%'} />
      },
      actions: {
        value: (
          <Stack flexDirection={'row'} gap={'10px'}>
            <img
              alt={'icon-eye'}
              src={'/icons/icon_eye.svg'}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (data?.storage?.url) {
                  window.open(data.storage.url, '_blank');
                }
              }}
            />
            <img
              alt={'icon-trash'}
              src={'/icons/icon_delete.svg'}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (deleteRecord) {
                  deleteRecord(data.id);
                }
              }}
            />
            {/*<img*/}
            {/*  alt={'icon-download'}*/}
            {/*  src={'/icons/icon_download.svg'}*/}
            {/*  style={{ cursor: 'pointer' }}*/}
            {/*  onClick={() => {*/}
            {/*    saveVideo(data.storage.url, 'example');*/}
            {/*  }}*/}
            {/*/>*/}
          </Stack>
        )
      }
    };
  });
};

export type TabDocumentsProps = {
  pagingInfo: PagingInfo;
  handleChangePage: (value: number) => void;
  handleSort: (orderBy: string) => void;
  handleDelete: (id: number) => void;
  sortOption: { field?: string; order?: string };
  onSearch?: (valueSearch: string) => void;
  searchValue?: string;
  dataDocuments: Document[];
};
/**
 * TabDocuments
 * @constructor
 */
export const TabDocuments = ({
  pagingInfo,
  handleChangePage,
  handleSort,
  handleDelete,
  sortOption,
  onSearch,
  searchValue = '',
  dataDocuments
}: TabDocumentsProps) => {
  const [valueSearch, setValueSearch] = useState<string>(searchValue);

  React.useEffect(() => {
    setValueSearch(searchValue);
  }, [searchValue]);
  // //download file intab document
  // const { setLoading } = useLoading();
  // const handleDownloadFilePdf = async (url: string, fileName: string) => {
  //   try {
  //     setLoading(true);
  //     await saveVideoFile(url, fileName);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  return (
    <Stack style={{ width: '100%', alignItems: 'flex-start' }} mt={3} mb={5}>
      <Stack flexDirection={'row'} gap={1.25}>
        <Stack gap={1}>
          <InputText
            startAdornment={
              <InputAdornment position="end">
                <IconButton>
                  <img alt={'icon-user'} src={'/icons/icon_search.svg'} width={24} />
                </IconButton>
              </InputAdornment>
            }
            placeholder={'Search'}
            inputProps={{
              value: valueSearch,
              style: {
                width: '352px',
                minHeight: '46px',
                height: '46px',
                padding: 0
              },
              onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                setValueSearch(event.target.value);
              },
              onKeyDown: (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                if (event.key === 'Enter') {
                  onSearch && onSearch(valueSearch);
                }
              }
            }}
          />
        </Stack>
        <ButtonCustom
          sx={{ width: 'max-content', height: '46px' }}
          label={'Search'}
          onClick={() => {
            onSearch && onSearch(valueSearch);
          }}
        />
      </Stack>
      <TableCustom
        onSortHeader={handleSort}
        sort={sortOption}
        data={renderDataTable({
          dataTable: dataDocuments,
          deleteRecord: handleDelete
        })}
        headers={HEADER_DOCUMENT}
        handleChooseRow={() => {}}
        styledTableRow={{ cursor: ' default ' }}
        pagingInfo={pagingInfo}
        handleChangePage={handleChangePage}
      />
    </Stack>
  );
};
